<app-event-table
  [loading]="loading"
  [eventSearchType]="EventSearchType.AllEvents"></app-event-table>
